var map = {
	"./base-widget": "./ClientApp/app/widgets/base-widget.ts",
	"./base-widget.ts": "./ClientApp/app/widgets/base-widget.ts",
	"./chart-widget": "app/widgets/chart-widget",
	"./chart-widget-configuration": "app/widgets/chart-widget-configuration",
	"./chart-widget-configuration.html": "app/widgets/chart-widget-configuration.html",
	"./chart-widget-configuration.ts": "app/widgets/chart-widget-configuration",
	"./chart-widget.html": "app/widgets/chart-widget.html",
	"./chart-widget.ts": "app/widgets/chart-widget",
	"./comparison-widget": "app/widgets/comparison-widget",
	"./comparison-widget-configuration": "app/widgets/comparison-widget-configuration",
	"./comparison-widget-configuration.html": "app/widgets/comparison-widget-configuration.html",
	"./comparison-widget-configuration.ts": "app/widgets/comparison-widget-configuration",
	"./comparison-widget.html": "app/widgets/comparison-widget.html",
	"./comparison-widget.ts": "app/widgets/comparison-widget",
	"./count-widget": "app/widgets/count-widget",
	"./count-widget-configuration": "app/widgets/count-widget-configuration",
	"./count-widget-configuration.html": "app/widgets/count-widget-configuration.html",
	"./count-widget-configuration.ts": "app/widgets/count-widget-configuration",
	"./count-widget.html": "app/widgets/count-widget.html",
	"./count-widget.ts": "app/widgets/count-widget",
	"./entity-finder": "app/widgets/entity-finder",
	"./entity-finder-configuration": "app/widgets/entity-finder-configuration",
	"./entity-finder-configuration.html": "app/widgets/entity-finder-configuration.html",
	"./entity-finder-configuration.ts": "app/widgets/entity-finder-configuration",
	"./entity-finder-widget": "app/widgets/entity-finder-widget",
	"./entity-finder-widget-configuration": "app/widgets/entity-finder-widget-configuration",
	"./entity-finder-widget-configuration.html": "app/widgets/entity-finder-widget-configuration.html",
	"./entity-finder-widget-configuration.ts": "app/widgets/entity-finder-widget-configuration",
	"./entity-finder-widget.html": "app/widgets/entity-finder-widget.html",
	"./entity-finder-widget.ts": "app/widgets/entity-finder-widget",
	"./entity-finder.html": "app/widgets/entity-finder.html",
	"./entity-finder.ts": "app/widgets/entity-finder",
	"./gauge-widget": "app/widgets/gauge-widget",
	"./gauge-widget-configuration": "./ClientApp/app/widgets/gauge-widget-configuration.ts",
	"./gauge-widget-configuration.html": "app/widgets/gauge-widget-configuration.html",
	"./gauge-widget-configuration.ts": "./ClientApp/app/widgets/gauge-widget-configuration.ts",
	"./gauge-widget.html": "app/widgets/gauge-widget.html",
	"./gauge-widget.ts": "app/widgets/gauge-widget",
	"./list-widget": "app/widgets/list-widget",
	"./list-widget-configuration": "app/widgets/list-widget-configuration",
	"./list-widget-configuration.html": "app/widgets/list-widget-configuration.html",
	"./list-widget-configuration.ts": "app/widgets/list-widget-configuration",
	"./list-widget.html": "app/widgets/list-widget.html",
	"./list-widget.ts": "app/widgets/list-widget",
	"./models": "./ClientApp/app/widgets/models.ts",
	"./models.ts": "./ClientApp/app/widgets/models.ts",
	"./text-widget": "app/widgets/text-widget",
	"./text-widget-configuration": "app/widgets/text-widget-configuration",
	"./text-widget-configuration.html": "app/widgets/text-widget-configuration.html",
	"./text-widget-configuration.ts": "app/widgets/text-widget-configuration",
	"./text-widget.html": "app/widgets/text-widget.html",
	"./text-widget.ts": "app/widgets/text-widget",
	"./widget-dialogs/view-query-dialog": "./ClientApp/app/widgets/widget-dialogs/view-query-dialog.ts",
	"./widget-dialogs/view-query-dialog.html": "app/widgets/widget-dialogs/view-query-dialog.html",
	"./widget-dialogs/view-query-dialog.ts": "./ClientApp/app/widgets/widget-dialogs/view-query-dialog.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./ClientApp/app/widgets ./ClientApp/app/widgets sync recursive ^\\.\\/.*$";